import Glide from '@glidejs/glide'
// Add your custom JS here.
( function( $ ) {
	var prev_scroll_top = 0;

	$(document).scroll(function() {
		let y = $(this).scrollTop();
		console.log( y );
		//if (y > prev_scroll_top && y > 220)
		if (y > 220)
		{
			$('#wrapper-navbar').removeClass( 'scrolled-up' );
			$('#wrapper-navbar').addClass( 'scrolled-down' );
		} else {
			$('#wrapper-navbar').removeClass( 'scrolled-down' );
			$('#wrapper-navbar').addClass( 'scrolled-up' );
		}
		prev_scroll_top = y;
	});

	var sonarkOffcanvas = document.getElementById('navbarNavOffcanvas')
	sonarkOffcanvas.addEventListener('show.bs.offcanvas', function () {
		$('.navbar-sonark .navbar-toggler').removeClass('collapsed');
	})
	sonarkOffcanvas.addEventListener('hide.bs.offcanvas', function () {
		$('.navbar-sonark .navbar-toggler').addClass('collapsed');
	})

	$(document).ready( function ()
	{
		
	});
	
	$(window).load( function()
	{
		if ( document.getElementById("start-slider") != null )
		{
			new Glide('#start-slider', {
				type: 'carousel',
				startAt: 0,
				perView: 1,
				gap: 0,
				autoplay: 8000,
				animationDuration: 1300,
				animationTimingFunc: 'ease-in-out',
				/*breakpoints: {
					991: {
						perView: 2,	
						autoplay: 3000,
					},
					767: {
						perView: 2,
						autoplay: 3000,
					},
					575: {
						perView: 1,
						autoplay: 3000,
					}
				}*/
			}).mount()
		}
	});

	const sonarkScrollToTop = function ()
	{
		const btnScrollTop = document.createElement('button');
		btnScrollTop.innerHTML = '<i class="fa fa-angle-up" aria-hidden="true"></i>';
		btnScrollTop.setAttribute( "id", "btn-scrolltop");
		document.body.appendChild(btnScrollTop);
		
		const displayBtn = function()
		{
			if ( window.scrollY > window.innerHeight )
			{
				if ( !btnScrollTop.classList.contains( 'show' ) )
					btnScrollTop.classList.add( "show" );
			}
			else {
				if ( btnScrollTop.classList.contains( 'show' ) )
					btnScrollTop.classList.remove( "show" );
			}
		};
		window.addEventListener( "scroll", displayBtn );
		
		const clickHandler = function ()
		{
			if (window.scrollY !== 0 )
			{
				$("html, body").animate( { scrollTop: "0" } );
			}
		};
		btnScrollTop.addEventListener( "click", clickHandler );
	}
	
	sonarkScrollToTop();
		
} )( jQuery );